import { render, staticRenderFns } from "./backgroundTopic.vue?vue&type=template&id=90bf9942&"
import script from "./backgroundTopic.vue?vue&type=script&lang=js&"
export * from "./backgroundTopic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports